<div style="overflow: hidden">
    <div class="flex-fill d-flex flex-column">
        <div class="modal-container">
            <div class="page-header title-margin">Edit Team</div>
            <button type="button" mat-icon-button aria-label="Close" class="close-x-btn" (click)="cancel()"
                style="position: absolute; top: 10px; right: 10px;">
                <mat-icon>close</mat-icon>
            </button>
            <form [formGroup]="editTeamForm" style="height: calc(90vh - 159px)">
                <div style="height: calc(90vh - 235px); margin-top: 5px;">
                    <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="selectedTabIndex = $event">
                        <!-- TEAM NAME tab -->
                        <mat-tab label="TEAM NAME">
                            <div class="mt-4 team-name-tab-container">
                                <div class="team-name-tab">
                                    <div class="form-fields-container" style="overflow: hidden;">
                                        <mat-form-field class="full-width form-field-container">
                                            <mat-label>Team Name</mat-label>
                                            <input matInput formControlName="teamName">
                                            <mat-error
                                                *ngIf="editTeamForm.get('teamName').hasError('required') || editTeamForm.get('teamName').hasError('whiteSpace')">
                                                <small>Required</small>
                                            </mat-error>
                                            <mat-error *ngIf="editTeamForm.get('teamName').hasError('maxlength')">
                                                <small>Maximum 50 characters allowed</small>
                                            </mat-error>
                                            <mat-error *ngIf="editTeamForm.get('teamName').hasError('duplicate')">
                                                <small>Team name already exists</small>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                        <!-- ADMINS tab -->
                        <mat-tab label="ADMINS">
                            <div class="mt-4">
                                <users-selection-table [users]="adminUserList" label="Users"
                                    [selectedUsers]="selectedAdminUsers"
                                    [showError]="editTeamForm.get('adminUsers').hasError('required')"
                                    (selectionChange)="onAdminSelectionChange($event)">
                                </users-selection-table>
                            </div>
                        </mat-tab>
                        <!-- MEMBERS tab -->
                        <mat-tab label="MEMBERS">
                            <div class="mt-4">
                                <users-selection-table [users]="teamMemberList" label="Users"
                                    [selectedUsers]="selectedTeamMembers"
                                    [showError]="editTeamForm.get('teamMembers').hasError('required')"
                                    (selectionChange)="onTeamMemberSelectionChange($event)">
                                </users-selection-table>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
                <div class="bottom-container" *ngIf="selectedTabIndex === 0">
                    <div class="delete-btn-box">
                        <button mat-button color="warn" class="delete-btn" (click)="deleteTeam()">
                            <mat-icon color="warn">delete</mat-icon>
                            DELETE TEAM
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div class="close-box">
            <button class="cancel-btn" type="button" mat-button color="primary" (click)="cancel()">
                CANCEL
            </button>
            <mrs-btn-primary buttonLabel="Save Changes" (onClick)="saveChanges()" [disabled]="!editTeamForm.valid">
            </mrs-btn-primary>

        </div>
    </div>
</div>